import { TicketCategory } from '@/types/ticket';
import { supabase } from '@/lib/supabase';
import { emailService } from './emailService';

interface CategoryAssignment {
  email: string;
  name: string;
}

const CATEGORY_ASSIGNMENTS: Record<TicketCategory, CategoryAssignment> = {
  [TicketCategory.SWA_REPORTING_BUG]: {
    email: 'allan.glasier@solerro.com',
    name: 'Allan Glasier'
  },
  [TicketCategory.SWA_FEATURE_REQUEST]: {
    email: 'allan.glasier@solerro.com',
    name: 'Allan Glasier'
  },
  [TicketCategory.SST_ISSUE]: {
    email: 'allan.glasier@solerro.com',
    name: 'Allan Glasier'
  },
  [TicketCategory.THR_ISSUE]: {
    email: 'allan.glasier@solerro.com',
    name: 'Allan Glasier'
  },
  [TicketCategory.D2D_ISSUE]: {
    email: 'allan.glasier@solerro.com',
    name: 'Allan Glasier'
  },
  [TicketCategory.GENERAL_TECH_ISSUE]: {
    email: 'allan.glasier@solerro.com',
    name: 'Allan Glasier'
  },
  [TicketCategory.GENERAL_SUPPORT_ISSUE]: {
    email: 'allan.glasier@solerro.com',
    name: 'Allan Glasier'
  },
  [TicketCategory.TEAM_ASSIGNMENT]: {
    email: 'princess.lamano@solerro.com',
    name: 'Princess Lamano'
  },
  [TicketCategory.MISSING_PROJECT_DATA]: {
    email: 'princess.lamano@solerro.com',
    name: 'Princess Lamano'
  }
};

export const ticketAssignmentService = {
  async getAssignedUser(category: TicketCategory): Promise<string> {
    // First, try to find the user by email
    const { data: user, error } = await supabase
      .from('users')
      .select('id')
      .eq('email', CATEGORY_ASSIGNMENTS[category].email)
      .single();

    if (error) {
      console.error('Error finding assigned user:', error);
      throw error;
    }

    if (!user) {
      throw new Error(`No user found with email ${CATEGORY_ASSIGNMENTS[category].email}`);
    }

    return user.id;
  },

  async getAssignmentDetails(userId: string): Promise<{ name: string; email: string }> {
    const { data, error } = await supabase
      .from('user_profiles')
      .select('email, name')
      .eq('id', userId)
      .single();

    if (error) {
      console.error('Error fetching assignment details:', error);
      return { name: 'Unknown User', email: '' };
    }

    // If name exists, use it, otherwise use email
    const displayName = data.name || data.email;
    return {
      name: displayName,
      email: data.email
    };
  },

  async getUsers(): Promise<{ id: string; name: string; email: string }[]> {
    const { data, error } = await supabase
      .from('user_profiles')
      .select('id, email, name')
      .order('name', { ascending: true, nullsFirst: false });

    if (error) throw error;
    return data.map(user => ({
      id: user.id,
      name: user.name || user.email,
      email: user.email
    }));
  },

  async sendNotification(ticketId: string, category: TicketCategory): Promise<void> {
    const assignment = CATEGORY_ASSIGNMENTS[category];
    
    // Send email notification using our email service
    try {
      await emailService.sendNotificationEmail({
        to: assignment.email,
        subject: `New Ticket Assigned: ${ticketId}`,
        message: `<h1>New Ticket Assigned</h1>
<p>A new ticket has been assigned to you.</p>
<p><strong>Ticket ID:</strong> ${ticketId}<br/>
<strong>Category:</strong> ${category}</p>
<p>Please check the support ticket system for details.</p>`,
        type: 'ticket_assigned',
        metadata: {
          ticket_id: ticketId,
          category: category
        }
      });
    } catch (error) {
      console.error('Error sending email notification:', error);
      throw error;
    }
  }
}; 